var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7292 74.0235L74.0339 56.7188L26.0838 8.76863L8.77911 26.0733L56.7292 74.0235Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7126 78.705L74.0283 56.7153L56.7229 74.0207L78.7126 78.705Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5265 68.4452L68.4451 76.519",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6795 12.8806L12.8806 3.6795C15.1199 1.44016 18.7455 1.44016 20.9849 3.6795L26.0729 8.76752L8.76752 26.0729L3.6795 20.9849C1.44016 18.7455 1.44016 15.1123 3.6795 12.8806Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7495 13.4366L13.4441 30.7496",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3756 65.368L22.0969 22.0969",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencilWhite.00c76c63eb0cda146400df1b871d02a5.svg";
export { ForwardRef as ReactComponent };